export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 1900;

  return Array.from({ length: currentYear - startYear + 1 }, (_, index) => ({
    text: (currentYear - index).toString(),
    value: currentYear - index,
  }));
};
